import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';

import OperatorEcAccountCreateForm from './OperatorEcAccountCreateForm';

// 新增模式：先選貨主再進表單
const OperatorEcAccountNew: React.FC = () => {
  return (
    <MerchantSelect>
      <OperatorEcAccountCreateForm />
    </MerchantSelect>
  );
};

export default OperatorEcAccountNew;
